module.exports = __webpack_public_path__ + "83019b513a569c95d54b197ce5967660.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-4.png
// module id = 124
// module chunks = 0